(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('service-time-session-servant', {
                parent: 'entity',
                url: '/service-time-session-servant?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceTimeSessionServant.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-time-session-servant/service-time-session-servants.html',
                        controller: 'ServiceTimeSessionServantController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceTimeSessionServant');
                        $translatePartialLoader.addPart('reserveTypes');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('service-time-session-servant-detail', {
                parent: 'entity',
                url: '/service-time-session-servant/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.serviceTimeSessionServant.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-time-session-servant/service-time-session-servant-detail.html',
                        controller: 'ServiceTimeSessionServantDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceTimeSessionServant');
                        $translatePartialLoader.addPart('reserveTypes');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'ServiceTimeSessionServant', function ($stateParams, ServiceTimeSessionServant) {
                        return ServiceTimeSessionServant.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('service-time-session-servant.new', {
                parent: 'service-time-session-servant',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session-servant/service-time-session-servant-dialog.html',
                        controller: 'ServiceTimeSessionServantDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    capacity: null,
                                    reserveType: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('service-time-session-servant', null, {reload: true});
                    }, function () {
                        $state.go('service-time-session-servant');
                    });
                }]
            })
            .state('service-time-session-servant.edit', {
                parent: 'service-time-session-servant',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session-servant/service-time-session-servant-dialog.html',
                        controller: 'ServiceTimeSessionServantDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ServiceTimeSessionServant', function (ServiceTimeSessionServant) {
                                return ServiceTimeSessionServant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-time-session-servant', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('service-time-session-servant.delete', {
                parent: 'service-time-session-servant',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-time-session-servant/service-time-session-servant-delete-dialog.html',
                        controller: 'ServiceTimeSessionServantDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceTimeSessionServant', function (ServiceTimeSessionServant) {
                                return ServiceTimeSessionServant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('service-time-session-servant', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
